<template>
  <div class="content_all2" id="site_int">
    <div class="content_box">
      <div class="site_inqbox">
        <table>
          <tr>
            <th>場館名稱</th>
            <td>
              <Select style="width:150px" v-model="buildingId" @on-change="getVenue">
                <Option v-for="(build,index) in building" :key="index" :value="build.id">{{build.buildingName}}</Option>
              </Select>
              <Select style="width:150px" v-model="venuesId">
                <Option v-if="venue.buildingId === buildingId" v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.venueName}}</Option>
              </Select>
              <!--               <button type="submit" class="btn_m">前往介紹</button>
 -->
            </td>
          </tr>
        </table>
      </div>
      <div class="list_box2" v-if="venuesId" v-html="showVenues.description">
      </div>
      <div class="list_box2" v-else>
        <p style="color: #bbb;font-style: italic;">請選擇場館</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
export default {
  name: 'site_int',
  data() {
    return {
      building: [],
      buildingId: 0,
      venues: [],
      venuesId: 0,
    };
  },
  created() {
    this.init();
  },
  computed: {
    showVenues() {
      for (var i in this.venues) {
        if (this.venues[i].id == this.venuesId) {
          return this.venues[i]
        }
      }
    }
  },
  methods: {
    init() {
      this.getBuild();
    },
    getBuild() {
      this.venues = []
      axios.get(API.rent_building)
        .then(response => {
          this.building = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.buildingId = response.data[0].id
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getVenue() {
      axios.get(API.rent_venue + `?buildingid=${this.buildingId}`)
        .then(response => {
          this.venues = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.venuesId = response.data[0].id
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// SiteInt.vue?2a6445d3